import ShareModelShow from "@/view/share_model/share_model_show.vue";
import ShareModelList from "@/view/share_model/share_model_list.vue";
import ShareModelEdit from "@/view/share_model/share_model_edit.vue";
import ShareModelNew from "@/view/share_model/share_model_new.vue";

const shareModel = [
  {
    path: "/share_model", 
    component: ShareModelList, 
    name: "share_model_list", 
    meta: {
      title: 'Modelo de Coparticipação',
      auth: false,
    }
  },
  {path: "/share_model/:id/show", component: ShareModelShow, name: "share_model_show"},
  {path: "/share_model/:id/edit", component: ShareModelEdit, name: "share_model_edit"},
  {path: "/share_model/new", component: ShareModelNew, name: "share_model_new"}
];

export default shareModel;
